import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/c7f165a9-564a-406c-bd8d-3b9ce6bc9ef7.png"
              alt="LocaCar"
              className="h-10 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-stone-400 text-sm leading-relaxed">
              Locação de veículos em Campinas e região. Sem entrada, sem burocracia. Apenas cadastro no app.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-instagram-line", "ri-facebook-circle-line", "ri-whatsapp-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 hover:bg-orange-500 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest text-stone-300 mb-4">
              <a href="#frota">Frota</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {["Econômicos", "SUVs", "Sedans", "Premium", "Vans", "Picapes"].map((item) => (
                <li key={item}>
                  <Link to="/busca" className="text-stone-400 text-sm hover:text-orange-400 transition-colors cursor-pointer">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest text-stone-300 mb-4">
              <a href="#empresa">Empresa</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: "Sobre nós", href: "#" },
                { label: "Agências", href: "/#mapa" },
                { label: "Ofertas", href: "/ofertas" },
                { label: "Como funciona", href: "/#como-funciona" },
                { label: "FAQ", href: "#" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="text-stone-400 text-sm hover:text-orange-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest text-stone-300 mb-4">
              <a href="#contato">Contato</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2 text-stone-400 text-sm">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-orange-400 text-sm"></i>
                </div>
                Campinas - SP, Brasil
              </li>
              <li className="flex items-center gap-2 text-stone-400 text-sm">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-orange-400 text-sm"></i>
                </div>
                (19) 3232-4500
              </li>
              <li className="flex items-center gap-2 text-stone-400 text-sm">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-orange-400 text-sm"></i>
                </div>
                contato@locacar.com.br
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            &copy; 2026 LocaCar. Todos os direitos reservados. Campinas - SP
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-stone-500 text-xs hover:text-stone-300 cursor-pointer">Termos de Uso</a>
            <a href="#" className="text-stone-500 text-xs hover:text-stone-300 cursor-pointer">Privacidade</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
